import React from 'react';
import './Legal.css';

const Legal: React.FC = () => {
  return (
    <div className="container legal-page">
      <div className="legal-header">
        <h1>Privacy, Terms & Legal</h1>
        <p>Last updated: January 16, 2026</p>
      </div>

      <section className="legal-section">
        <h2>Privacy Overview</h2>
        <p>
          We collect only the information required to operate your account, fulfill orders, and
          provide customer support. This may include your name, email, shipping details, and
          wallet activity. We do not sell personal information to third parties.
        </p>
        <p>
          We may use trusted service providers to process payments, secure our platform, and
          deliver communications. These providers are required to protect your data.
        </p>
      </section>

      <section className="legal-section">
        <h2>Account & Membership Terms</h2>
        <ul>
          <li>No sharing of account credentials or access is allowed.</li>
          <li>Membership fees may be reviewed in the future and adjusted with notice.</li>
          <li>We may suspend or terminate accounts that violate these terms.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Wallet & Payments</h2>
        <ul>
          <li>Wallet funds are for purchases only; no cash withdrawals are available.</li>
          <li>Top-ups and purchases are subject to verification and fraud checks.</li>
          <li>All wallet transactions are recorded for account security and compliance.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Points & Rewards</h2>
        <ul>
          <li>The company has sole discretion to determine the value of points.</li>
          <li>Points have no cash value and may be modified or discontinued at any time.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Purchases & Usage</h2>
        <ul>
          <li>No purchase for the purpose of reselling is allowed.</li>
          <li>Orders may be limited to protect fair access to inventory.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Contact</h2>
        <p>
          If you have questions about these terms, contact support through your account dashboard.
        </p>
      </section>
    </div>
  );
};

export default Legal;
